import {IManufacturer} from 'interfaces';
import {axiosAPI} from './API';

// Singleton for interacting with manufacturers
class _ManufacturersService {

    public manufacturerNames: string[] = [""];

    public getManufacturers = (): Promise<IManufacturer[]> => {

        const p = axiosAPI.get<IManufacturer[]>('/manufacturers')
            .then((resp) => {
                let mans = resp.data;

                const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
                mans.sort((a, b) => collator.compare(a.name, b.name));

                let manNames = mans.map((m) => m.name);
                this.manufacturerNames.push(...manNames);

                return mans;
            });
            
        p.catch((err) => {
            console.error('Error getting manufacturers: ', err);
        });

        return p;
    }
}

export const ManufacturersService = new _ManufacturersService();
